import { Col, Form } from "react-bootstrap";
import Typography from "@mui/material/Typography";
import { useActuatorConfigurationContext } from "context/ActuatorConfigurationContext";

/**
 * Guard Times configuration for 4-wire motor controller (read-only display)
 * CONFIG format: ["grd_time_onoff", "grd_time_offon"] (string values in seconds)
 * - grd_time_onoff: guard time from ON to OFF state
 * - grd_time_offon: guard time from OFF to ON state
 */
const GuardTimes = () => {
    const { guardTimesConfig }: { guardTimesConfig: string[] | null } =
        useActuatorConfigurationContext();

    // Parse CONFIG array: [on_to_off, off_to_on]
    const onToOffValue = guardTimesConfig?.[0] ?? "";
    const offToOnValue = guardTimesConfig?.[1] ?? "";

    return (
        <>
            <div className="form-box-head pb-4 mt-3">
                <h5 className="float-left">Guard Times</h5>
            </div>
            <div className="form-box">
                <Form.Row className="align-items-center mb-3">
                    <Col md={3}>
                        <Form.Label className="mb-0">ON to OFF time</Form.Label>
                    </Col>
                    <Col md={7}>
                        <Form.Control
                            type="text"
                            value={onToOffValue}
                            disabled
                            readOnly
                            className="guard-time-input"
                        />
                    </Col>
                    <Col md={2}>
                        <span>(Seconds)</span>
                    </Col>
                </Form.Row>
                <Form.Row className="align-items-center">
                    <Col md={3}>
                        <Form.Label className="mb-0">OFF to ON time</Form.Label>
                    </Col>
                    <Col md={7}>
                        <Form.Control
                            type="text"
                            value={offToOnValue}
                            disabled
                            readOnly
                            className="guard-time-input"
                        />
                    </Col>
                    <Col md={2}>
                        <span>(Seconds)</span>
                    </Col>
                </Form.Row>
            </div>
            <div className="form-box mt-3">
                <Typography variant="body1">Note:</Typography>
                <Typography variant="body2" color="#828FAB" className="mt-2 mb-0">
                    Guard time is the minimum waiting period between motor
                    commands. Manual activation and deactivation must follow
                    this timing; otherwise, the command may be ignored.
                </Typography>
            </div>
        </>
    );
};

export default GuardTimes;
